module.exports = __webpack_public_path__ + "img/print.e16c9784.png";